import type { EffectiveRole } from '@domain/entities';
import type { IAccessRepository } from '@domain/repositories';
import type { AssignRolePayload } from '@application/dto';

export class AssignRoleUseCase {
  constructor(private readonly accessRepository: IAccessRepository) {}

  async execute(userId: string, payload: AssignRolePayload): Promise<EffectiveRole[]> {
    return this.accessRepository.assign(userId, payload);
  }
}
